//comment or article
export enum LikeCategory {
  comments = 'comments',
  articles = 'articles'
}
